import { z } from "zod";

export const billingWindowLimitsSchema = z.object({
  perMinute: z.number().int().nonnegative().nullable().optional(),
  perHour: z.number().int().nonnegative().nullable(),
  perDay: z.number().int().nonnegative().nullable(),
  perMonth: z.number().int().nonnegative().nullable(),
  maxConcurrent: z.number().int().nonnegative().nullable().optional(),
  includedPerMonth: z.number().int().nonnegative().optional(),
});

export const billingTierLimitsSchema = z.object({
  training_job: billingWindowLimitsSchema,
  eval_run_sample: billingWindowLimitsSchema,
  deployment_active: billingWindowLimitsSchema,
  deployment_gpu_hour: billingWindowLimitsSchema,
  serverless_inference: billingWindowLimitsSchema,
  third_party_serverless_inference: billingWindowLimitsSchema,
  proxied_inference_requests: billingWindowLimitsSchema,
  proxied_inference_data_bytes: billingWindowLimitsSchema,
  otel_span_count: billingWindowLimitsSchema,
  otel_span_data_bytes: billingWindowLimitsSchema,
  halo_run: billingWindowLimitsSchema,
  halo_inference_cost: billingWindowLimitsSchema,
  signal_span_classification: billingWindowLimitsSchema,
  signal_trace_classification: billingWindowLimitsSchema,
  signal_session_classification: billingWindowLimitsSchema,
});
